/* ImportAction.js */

"use strict";
// const Registrations = require("../../../../../RegistrationNamespaces");
// const _ = require("lodash");
const ImportScreenComponent = require("./ImportScreenComponent");
const ImportSummaryComponent = require("./ImportSummary/ImportSummaryComponent");

const NON_IMPORTABLE = ["shared", "private", "defaultForDm", "defaultForCda", "defaultForOsm"];

class ImportAction {
    constructor(logger, gameEditor, modalUserFeedback, ExplorerTemplate, userSession, activeView, steveIo, activityMonitor, CustomFields) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._templateEntity = ExplorerTemplate;

        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._userSession = userSession;
        this._steveIo = steveIo;
        this._activityMonitor = activityMonitor;
        this._CustomFieldsEntity = CustomFields;
        this._activeOrgId = this._userSession.activeOrganization.id;

        this.run = this.run.bind(this);
    }

    run() {
        let importScreenComponent = new ImportScreenComponent(this._logger, this._userSession, this._steveIo);
        let isUploadingReady = false;
        const ActivityMonitor = this._activityMonitor;
        const sessionExpiredTime = ActivityMonitor._options.pollingInterval * ActivityMonitor._options.maxInactivityPolls - 1000;

        /** Checks current loading time and prevents user session times out */
        let startCheckTimer = function () {
            if (isUploadingReady === true) {
                // Loading is done, turn off the checker
                return;
            } else {
                // Extend user session, and load timer again
                ActivityMonitor._resetInactivityPolls();
                setTimeout(startCheckTimer, sessionExpiredTime);
            }
        };

        return this._modalUserFeedback
            .displayCustom(importScreenComponent, {
                dontHide: true
            })
            .then((res) => {
                this._modalUserFeedback.displayLoading({
                    message: "Importing your file... This could take a moment"
                });
                // Let check results in 15 minutes
                setTimeout(startCheckTimer, sessionExpiredTime);

                const importedData = res.importData;
                const importedTemplates = importedData.map((temp) => {
                    if (!temp.name) {
                        return Promise.reject({
                            errorMsg: "Imported template must have a name",
                            errorCode: "SyntaxError"
                        });
                    }
                    const template = new this._templateEntity(this._activeOrgId);
                    for (let prop in temp) {
                        if (NON_IMPORTABLE.indexOf(prop) < 0) {
                            template[prop] = temp[prop];
                        }
                    }
                    const columnsList = template.columns;
                    // console.log(columnsList);
                    return this._CustomFieldsEntity.loadCustomFields(this._activeOrgId).then((cfentity) => {
                        const fields = cfentity.fields;
                        const cfids = Object.keys(fields);
                        const cfields = Object.entries(fields);
                        let colError = false;
                        columnsList.forEach((col) => {
                            if (!col.flattenedPath) {
                                colError = true;
                                return;
                            }
                            if (col.path[0] === "customFieldValues") {
                                if (cfids.indexOf(col.path[1]) < 0) {
                                    for (let i = 0; i < cfields.length; i++) {
                                        if (
                                            col.flattenedPath.split(">")[1] === cfields[i][1].name &&
                                            col.dataType.toLowerCase() === cfields[i][1].dataType.toLowerCase()
                                        ) {
                                            // console.log(col, cfields[i]);
                                            col.path[1] = cfields[i][0];
                                            break;
                                        }
                                    }
                                }
                            }
                        });
                        template.columns = columnsList;
                        // console.log(template.columns);
                        // console.log(template);
                        if (colError) {
                            return Promise.reject({
                                errorMsg: `Sorry! The template "${template.name}" you are trying to import is not supported::Missing fields`
                            });
                        }
                        return template.create();
                    });
                });
                return Promise.allSettled(importedTemplates);
            })
            .then((resultTemplates) => {
                isUploadingReady = true;
                const results = {
                    summary: {},
                    successMessages: [],
                    errorMessages: []
                };
                results.summary = {
                    targetCount: resultTemplates.length,
                    successCount: 0,
                    failureCount: 0,
                    templateCreateCount: 0
                };
                let successMessage = "";
                let errorMessage = "";
                resultTemplates.forEach((resultTemplate, idx) => {
                    if (resultTemplate.status === "fulfilled") {
                        results.summary.successCount++;
                        let isLastItem = resultTemplates.length + 1 === idx;
                        const msg = "Template - " + resultTemplate.value.name + ", imported successfully";
                        successMessage += msg + (isLastItem ? "" : "\r\n");
                        results.successMessages.push(msg);
                    } else {
                        results.summary.failureCount++;
                        errorMessage += resultTemplate.reason.errorMsg + "\r\n";
                        results.errorMessages.push(resultTemplate.reason.errorMsg);
                    }
                });
                results.successMessage = successMessage;
                results.errorMessage = errorMessage;
                results.summary.templateCreateCount = results.summary.successCount;
                successMessage += errorMessage;
                // if (
                //     this._activeView &&
                //     this._activeView.pagingFeed &&
                //     this._activeView.pagingFeed.feedUpdate
                // ) {
                //     this._activeView.pagingFeed.feedUpdate();
                // }

                return this._modalUserFeedback.displayCustom(new ImportSummaryComponent(results, this._logger));
            })
            .catch((err) => {
                isUploadingReady = true;
                if (err.userRejected) {
                    this._logger.warn({ error: err }, "Template::ImportAction.run() - User Canceled.");
                    return this._modalUserFeedback.hideDisplayed();
                } else {
                    this._logger.warn({ error: err }, "Template::ImportAction.run() - Error");
                    return this._modalUserFeedback.displayError(err).catch(() => {
                        return Promise.resolve();
                    });
                }
            });
    }
}

module.exports = ImportAction;

ImportAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.ExplorerTemplate",
    "$teve.userSession",
    "gameEditor.activeView",
    "$teve.io",
    "$teve.activityMonitor",
    "$teve.entities.CustomFields"
];

ImportAction.$displayDetails = {
    type: "Action",
    name: "ImportAction",
    icon: "configdrift.import_devices",
    shown: true,
    title: "Import templates",
    order: 3
};
